/**
 * Kinds of promo the Promos system manages. Only "NextOn" promos belong to an
 * episode (and therefore need a Ref ID); Scheduler inserts NextOns only.
 * Keep in sync with the backend's promos/helpers.ts.
 */
export const PROMO_TYPES = ["NextOn", "Break Fill"] as const;

export type PromoType = (typeof PROMO_TYPES)[number];

export const PROMO_TYPE_OPTIONS = PROMO_TYPES.map(type => ({ label: type, value: type }));

export const DEFAULT_PROMO_TYPE: PromoType = "NextOn";
